/* eslint react/require-default-props: 0 */
/* eslint react/jsx-boolean-value: 0 */
import {
  faLayerGroup, faStar,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import Markdown from 'markdown-to-jsx';
import PropTypes from 'prop-types';
import React from 'react';
import { Card, CardBody } from 'reactstrap';
import Title from '@components/Title';
import constructRelativeLink from '@utils/construct-relative-link';
import cx from 'classnames';

import Link from '@components/Link';
import './index.scss';

const CardButton = (props) => {
  const {
    altText, ariaLabel, featured, imgSrc, link, tag, title,
    body, topics, newTab, titleSize, brandColorOverride,
  } = props;
  let source = '';

  // Handle both image nodes from yaml files and markdown nodes from templates
  if (imgSrc !== null && typeof imgSrc === 'object') {
    source = imgSrc.childImageSharp ? imgSrc.childImageSharp.fluid : imgSrc;
  }

  if (imgSrc !== null && typeof imgSrc === 'string') {
    source = imgSrc;
  }

  // TODO: We should be more strict about whether a url or fluid object is passed in.
  if (source.fluid) source = source.fluid;
  let tagIcon = '';
  let tagLabel = '';

  switch (tag) {
    case 'group':
      tagIcon = faLayerGroup;
      break;
    case 'pdf':
      tagLabel = 'pdf';
      break;
    case 'zip':
      tagLabel = 'zip';
      break;
    default:
      tagIcon = '';
      tagLabel = ' ';
  }

  return (
    <Card className="card-button mb-3" data-cy="card-button">
      {featured && (
        <div className="featured">
          <FontAwesomeIcon
            className="icon"
            icon={faStar}
            size="lg"
          />
        </div>
      )}
      <Link ariaLabel={ariaLabel} to={constructRelativeLink(link)} newTab={newTab}>
        {imgSrc && typeof imgSrc === 'object' && (
          <GatsbyImage
            alt={altText}
            data-cy="gatsby-img"
            image={getImage(imgSrc)}
          />
        )}
        <CardBody style={{ borderTopColor: brandColorOverride }}>
          {title && <Title title={title} titleSize={titleSize} classes={cx('mb-0', titleSize === 'h3' && 'card-title', titleSize === 'h2' && 'card-button-title')} cypressDataAttr="card-button-title" />}
          {body && <p><Markdown>{body}</Markdown></p>}
          {tag !== '' && (
            <div className="tag-container">
              {tagIcon && (<FontAwesomeIcon className="icon" icon={tagIcon} size="sm" />)}
              {tagLabel}
              <span className="tag-text">{topics && topics[0] && ` ${topics[0]}`}</span>
              <span className="tag-text" style={{ margin: 0 }}>{topics && topics[1] && ','}</span>
              <span className="tag-text">{topics && topics[1] && `${topics[1]}`}</span>
              <span className="tag-text" style={{ margin: 0 }}>{topics && topics[2] && topics[2] && ','}</span>
              <span className="tag-text">{topics && topics[2] && `${topics[2]}`}</span>
            </div>
          )}
        </CardBody>
      </Link>
    </Card>
  );
};

CardButton.defaultProps = {
  altText: '',
  ariaLabel: '',
  body: '',
  imgSrc: null,
  featured: false,
  tag: '',
  topics: [],
  titleSize: '',
  brandColorOverride: null,
};

CardButton.propTypes = {
  altText: PropTypes.string,
  ariaLabel: PropTypes.string,
  body: PropTypes.string,
  // TODO: Fix this eslint warning and remove whitelisting
  // eslint-disable-next-line react/forbid-prop-types
  imgSrc: PropTypes.objectOf(PropTypes.any),
  featured: PropTypes.bool,
  link: PropTypes.string.isRequired,
  tag: PropTypes.string,
  topics: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
  titleSize: PropTypes.string,
  newTab: PropTypes.bool,
  brandColorOverride: PropTypes.string,
};

export default CardButton;
